import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { I18nProvider } from "@/contexts/I18nContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { SiteImagesProvider } from "@/contexts/SiteImagesContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AIChat from "@/components/AIChat";
import Home from "@/pages/Home";
import PlacesList from "@/pages/PlacesList";
import PlaceDetail from "@/pages/PlaceDetail";
import MapPage from "@/pages/MapPage";
import MapsPage from "@/pages/MapsPage";
import ItinerariesList from "@/pages/ItinerariesList";
import ItineraryDetail from "@/pages/ItineraryDetail";
import Downloads from "@/pages/Downloads";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      <AIChat />
    </>
  );
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/places" element={<PublicLayout><PlacesList /></PublicLayout>} />
      <Route path="/places/:slug" element={<PublicLayout><PlaceDetail /></PublicLayout>} />
      <Route path="/map" element={<PublicLayout><MapPage /></PublicLayout>} />
      <Route path="/maps" element={<PublicLayout><MapsPage /></PublicLayout>} />
      <Route path="/itineraries" element={<PublicLayout><ItinerariesList /></PublicLayout>} />
      <Route path="/itineraries/:slug" element={<PublicLayout><ItineraryDetail /></PublicLayout>} />
      <Route path="/downloads" element={<PublicLayout><Downloads /></PublicLayout>} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="*" element={<PublicLayout><div className="max-w-7xl mx-auto px-5 py-32 text-center"><h1 className="font-display text-5xl">404</h1></div></PublicLayout>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <SiteImagesProvider>
            <BrowserRouter>
              <Shell />
            </BrowserRouter>
          </SiteImagesProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
